<div class="login-page">
  <div class="login-container">
    <!-- Background Elements -->
    <div class="background-elements">
      <div class="circle circle-1"></div>
      <div class="circle circle-2"></div>
      <div class="circle circle-3"></div>
    </div>

    <!-- Main Content -->
    <div class="login-content">
      <!-- Logo Section -->
      <div class="logo-section">
        <!-- <div class="logo-container">
          <img src="logo.png" class="logo" alt="Logo">
        </div> -->
        <h1 class="app-title">QRserve Waiter</h1>
        <!-- <p class="app-subtitle">Hotel Management System</p> -->
      </div>

      <!-- Login Form -->
      <div class="login-card">
        <div class="card-header">
          <h2 class="login-title">Welcome Back</h2>
          <p class="login-subtitle">Please sign in to your account</p>
        </div>

        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form">
          <!-- Email Field -->
          <div class="form-group">
            <label for="email" class="form-label">
              <i class="fa fa-envelope"></i>
              Email Address
            </label>
            <div class="input-wrapper">
              <input
                type="email"
                id="email"
                formControlName="email"
                class="form-input"
                placeholder="Enter your email"
                [class.error]="loginForm.get('email')?.invalid && loginForm.get('email')?.touched">
            </div>
            @if(loginForm.get('email')?.invalid && loginForm.get('email')?.touched) {
              <span class="error-message">Please enter a valid email address</span>
            }
          </div>

          <!-- Password Field -->
          <div class="form-group">
            <label for="password" class="form-label">
              <i class="fa fa-lock"></i>
              Password
            </label>
            <div class="input-wrapper password-wrapper">
              <input
                [type]="showPassword ? 'text' : 'password'"
                id="password"
                formControlName="password"
                class="form-input"
                placeholder="Enter your password"
                [class.error]="loginForm.get('password')?.invalid && loginForm.get('password')?.touched">
              <button type="button" class="toggle-password" (click)="togglePassword()">
                <i class="fa" [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
              </button>
            </div>
            @if(loginForm.get('password')?.invalid && loginForm.get('password')?.touched) {
              <span class="error-message">Password is required</span>
            }
          </div>

          <!-- Error Message -->
          @if(message) {
            <div class="alert alert-error">
              <i class="fa fa-exclamation-triangle"></i>
              {{message}}
            </div>
          }

          <!-- Submit Button -->
          <button
            type="submit"
            class="login-btn"
            [disabled]="isLoading || loginForm.invalid"
            [class.loading]="isLoading">
            @if(isLoading) {
              <div class="btn-loader">
                <div class="spinner"></div>
                <span>Signing In...</span>
              </div>
            } @else {
              <span>Sign In</span>
              <i class="fa fa-arrow-right"></i>
            }
          </button>
        </form>

        <!-- Additional Links -->
        <div class="form-footer">
          <a href="#" class="forgot-password">Forgot your password?</a>
        </div>
      </div>
    </div>

    <!-- Loading Overlay -->
    @if(isLoading) {
      <div class="loading-overlay">
        <div class="loading-content">
          <div class="main-loader">
            <div class="loader-circle"></div>
            <div class="loader-circle"></div>
            <div class="loader-circle"></div>
          </div>
          <p class="loading-text">Authenticating...</p>
        </div>
      </div>
    }
  </div>
</div>
